import { createAction, props } from '@ngrx/store';
import { UserModel } from '../../models/user.model';

export const loadUser = createAction(
  '[Auth] Load User',
  props<{ uid: string }>()
);
export const getUser = createAction(
  '[Auth] Get User',
  props<{ uid: string }>()
);
export const loadUserSuccess = createAction(
  '[Auth] Load User Success',
  props<{ user: UserModel }>()
);
export const loadUserFailure = createAction(
  '[Auth] Load User Failure',
  props<{ error: any }>()
);
export const signup = createAction(
  '[Auth] Signup',
  props<{ email: string; password: string }>()
);
export const signupSuccess = createAction('[Auth] Signup Success');
export const signupFailure = createAction(
  '[Auth] Signup Failure',
  props<{ error: any }>()
);

export const verifyEmail = createAction(
  '[Auth] Verify Email',
  props<{ uid: string }>()
);
export const verifyEmailSuccess = createAction('[Auth] Verify Email Success');
export const verifyEmailFailure = createAction(
  '[Auth] Verify Email Failure',
  props<{ error: any }>()
);

export const resetPassword = createAction(
  '[Auth] Reset Password',
  props<{ email: string }>()
);
export const resetPasswordSuccess = createAction(
  '[Auth] Reset Password Success'
);
export const resetPasswordFailure = createAction(
  '[Auth] Reset Password Failure',
  props<{ error: any }>()
);

export const update = createAction(
  '[Auth] Update User',
  props<{ user: UserModel }>()
);
export const deleteImage = createAction(
  '[Auth] Delete Profile Image',
  props<{ user: UserModel }>()
);
export const updateSuccess = createAction(
  '[Auth] User Update Success',
  props<{ user: UserModel }>()
);
export const updateFailure = createAction(
  '[Auth] User Update Failure',
  props<{ error: any }>()
);

export const emailLogin = createAction(
  '[Auth] Email Login',
  props<{ username: string; password: string }>()
);
export const googleLogin = createAction('[Auth] Google Login');
export const appleLogin = createAction('[Auth] Apple Login');

export const loginSuccess = createAction(
  '[Auth] Login Success',
  props<{ user: UserModel }>()
);
export const loginFailure = createAction(
  '[Auth] Login Failure',
  props<{ error: any }>()
);

export const clearError = createAction('[Auth] Clear Error');

export const authenticated = createAction(
  '[Auth] Authenticated',
  props<{ user: UserModel }>()
);
export const notAuthenticated = createAction('[Auth] Not Authenticated');

export const logout = createAction('[Auth] Logout');
export const logoutSuccess = createAction('[Auth] Logout Success');
